/** M249, as a thing you can carry. The gun itself is `sim/weapons/guns/m249.ts`. */

import { NO_ARMOR } from '@/sim/combat/armorMitigation';
import type { WeaponItem } from '@/sim/items/itemContract';

export const M249_ITEM = {
  id: 'm249',
  kind: 'weapon',
  label: 'M249',
  description:
    'A hundred rounds on a belt and a bipod to hold them still. Nobody crosses the street.',
  rarity: 'rare',
  weightKg: 7.5,
  stackLimit: 1,
  equip: {
    slots: ['primaryWeapon'],
    statDeltas: {},
    armor: NO_ARMOR,
    damageModifiers: [],
  },
  weaponId: 'm249',
} as const satisfies WeaponItem;
